class VideoBackground {
  constructor($element) {
    this.$element = $element;

    this.bindUI();

    if (this.$video) {
      this.bindEvents();
      this.bindObservers();
    }
  }

  bindEvents() {
    this.$video.addEventListener( 'play', () => {
      // If the video started playing, we're probably not in low power mode and
      // it should be displayed.
      this.hideVideo = false;
      this.render();
    } );
  }

  bindObservers() {
    const options = {
      root: null,
      rootMargin: '100px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting) {
        if (this.$video.paused && !this.$video.ended) {
          // If the <video> element is visible and is paused but not ended,
          // we may be in low power mode. Hide the element so play controls
          // aren't visible underneath module text.
          this.hideVideo = true;
        } else {
          this.hideVideo = false;
        }
      }

      this.render();
    }, options);
    observer.observe(this.$video);
  }

  bindUI() {
    this.$video = this.$element.querySelector('video');
  }

  render() {
    if (this.hideVideo) {
      this.$video.style.opacity = 0;
    } else {
      this.$video.style = '';
    }
  }
}

document.querySelectorAll('[data-video-background="true"]')
  .forEach(($element) => {
    new VideoBackground($element);
  });
